<template>
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog" style="max-width:1200px;">
            <div class="modal-content" style="min-height: 420px;">
                <div class="modal-header">
                    <h2>{{ titulo }}</h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
                        </span>
                    </div>
                </div>
                <div class="modal-body scroll-y m-5">
                    <div class="row g-6 g-xl-12">
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label for="nome" class="form-check-label">Nome:</label>
                                <input required type="text" name="nome" class="form-control" v-model="nome">
                            </div>
                        </div>
                        <div class="col-12 col-sm-6" v-if="status">
                            <div class="form-group">
                                <label for="status" class="form-check-label">Status:</label>
                                <Multiselect v-model="statusId" :options="statusSelect" :searchable="true"></Multiselect>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="descricao" class="form-check-label">Descricao:</label>
                                <textarea required rows="3" name="descricao" class="form-control" v-model="descricao"></textarea>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="observacao" class="form-check-label">Observacao:</label>
                                <textarea rows="3" name="observacao" class="form-control" v-model="observacao"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <BotaoSalvar @click="salvar" :processando="processando" titulo="Atualizar"></BotaoSalvar>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Multiselect from '@vueform/multiselect'
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import { Options, Vue } from "vue-class-component";
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import SiteUtils from '@/assets/ts/aplicacao/site';
    import $ from "jquery"
    import { Prop, Watch } from 'vue-property-decorator';
    import EspacoService from "@/service/v1/sigap/EspacoService"

    @Options({
        name: "EspacoEditar",
        components: { Multiselect, BotaoSalvar },
        emits: ['espaco-alterado'],
    })
    export default class EspacoEditar extends Vue {
        @Prop() readonly modal!: any
        @Prop() readonly perfis!: any
        @Prop() readonly modelo!: any
        @Prop() readonly service!: any

        public processando = false;
        public titulo = 'Atualizar Espaco';

        public id: any = null;
        public nome: any = null;
        public descricao: any = null;
        public observacao: any = null;
        public statusId: any = null;
        public status: any = null;

        public espacoService = new EspacoService();

        created() {
            this.getStatus();
        }

        @Watch('modelo')
        public modeloAlterado() {
            if (!this.modelo || !this.modelo.id) {
                return;
            }
            this.processando = true;
            this.espacoService.getModel(this.modelo.id)
                .then(response => {
                    this.id = response.id;
                    this.nome = response.nome;
                    this.descricao = response.descricao;
                    this.observacao = response.observacao;
                    this.statusId = response.status?.id ?? response.status;
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    this.nome = null;
                    this.descricao = null;
                    this.observacao = null;
                    this.statusId = null;
                });
        }

        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
        }

        get statusSelect() {
            if (this.status) {
                return this.status.map((item) => { return { value: item.id, label: item.nome } });
            }
            return null;
        }

        public getStatus() {
            this.processando = true;
            this.espacoService.getStatus()
                .then(response => {
                    this.status = JSON.parse(JSON.stringify(response));
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                });
        }

        public getdados() {
            const dados: any = {};
            dados.id = this.id;
            dados.nome = this.nome;
            dados.descricao = this.descricao;
            dados.observacao = this.observacao;
            dados.status = this.statusId;
            return dados;
        }

        public sucesso() {
            this.$emit("espaco-alterado", null);
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }

        public salvar() {
            if (this.processando || !this.hasPermissao) {
                return;
            }
            if (!this.id || !this.nome || !this.descricao || !this.statusId) {
                SiteUtils.toastErro('Error!', 'Preencha nome, descricao e status.');
                return;
            }
            this.processando = true;
            const dados = this.getdados();
            setTimeout(() => {
                this.service.update(this.id, dados)
                    .then(response => {
                        SiteUtils.toastSucesso('Atualizado com sucesso!', response.message);
                        this.sucesso();
                        this.processando = false;
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro('Error!', error.data.message);
                    });
            }, 100);
        }
    }
</script>
